import Swal from 'sweetalert2'

interface ConfirmDialogOptions {
  title: string
  text?: string
  confirmVariant?: 'primary' | 'danger'
  confirmLabel?: string
  cancelLabel?: string
}

/**
 * Frontend Spec §5.1: destructive actions require explicit confirmation
 * before executing. Single shared entry point so every danger action in the
 * app (Button's danger variant, admin block/unblock, team deactivate, etc.)
 * confirms the same way.
 */
export async function confirmDialog({
  title,
  text,
  confirmVariant = 'primary',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
}: ConfirmDialogOptions): Promise<boolean> {
  const result = await Swal.fire({
    title,
    text,
    icon: confirmVariant === 'danger' ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonText: confirmLabel,
    cancelButtonText: cancelLabel,
    confirmButtonColor: confirmVariant === 'danger' ? '#dc3545' : '#0d6efd',
    reverseButtons: true,
    focusCancel: confirmVariant === 'danger',
  })

  return result.isConfirmed
}
